import { render, staticRenderFns } from "./SoliReview.vue?vue&type=template&id=61e48ebd&scoped=true"
import script from "./SoliReview.vue?vue&type=script&lang=js"
export * from "./SoliReview.vue?vue&type=script&lang=js"
import style0 from "./SoliReview.vue?vue&type=style&index=0&id=61e48ebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e48ebd",
  null
  
)

export default component.exports